// Browser-local queue of Finn ads collected by the bookmarklet (lib/finnBookmarklet.js).
// Each bookmarklet run lands here; the import drawer imports the whole queue at once.
// Stored in localStorage, so it lives in one browser only and never reaches the server.

const STORAGE_KEY = 'marketplaceFinnImportQueue';
// Same cap as the bookmarklet itself.
const MAX_QUEUE = 200;

function getStorage() {
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
    } catch (error) {
        return null;
    }
}

function queueKey(ad) {
    if (!ad) {
        return '';
    }
    if (ad.sourceId) {
        return `id:${ad.sourceId}`;
    }
    return ad.externalUrl ? `url:${ad.externalUrl}` : '';
}

export function loadFinnQueue() {
    const storage = getStorage();
    if (!storage) {
        return [];
    }
    try {
        const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(parsed) ? parsed.filter(ad => queueKey(ad)) : [];
    } catch (error) {
        return [];
    }
}

export function saveFinnQueue(ads) {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        if (!Array.isArray(ads) || ads.length === 0) {
            storage.removeItem(STORAGE_KEY);
        } else {
            storage.setItem(STORAGE_KEY, JSON.stringify(ads.slice(-MAX_QUEUE)));
        }
    } catch (error) {
        // Storage full or blocked: the ads of this run are still imported, only not remembered.
    }
}

// Adds a bookmarklet run to the queue. An ad already queued (same Finn id, else same url)
// is replaced in place so a re-run refreshes price/images; new ads go last.
export function mergeFinnQueue(existing, incoming) {
    const result = Array.isArray(existing) ? existing.filter(ad => queueKey(ad)) : [];
    (Array.isArray(incoming) ? incoming : []).forEach((ad) => {
        const key = queueKey(ad);
        if (!key) {
            return;
        }
        const index = result.findIndex(queued => queueKey(queued) === key);
        if (index >= 0) {
            result[index] = ad;
        } else {
            result.push(ad);
        }
    });
    return result.slice(-MAX_QUEUE);
}

// Drops the ads whose Finn ids (or urls) are listed, e.g. after a finished import.
export function removeFromFinnQueue(existing, ads) {
    const keys = new Set((Array.isArray(ads) ? ads : []).map(queueKey).filter(Boolean));
    return (Array.isArray(existing) ? existing : []).filter(ad => !keys.has(queueKey(ad)));
}

export function clearFinnQueue() {
    saveFinnQueue([]);
}

export { MAX_QUEUE as FINN_QUEUE_MAX };
